import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-form"
export default class extends Controller {
  connect() {
    this.checks = this.element.querySelectorAll("input[type=checkbox]")
    // console.log(this.element)

    this.checks.forEach(check => {
      check.addEventListener('change', this.submitForm.bind(this))
    })
  }

  submitForm() {
    this.element.requestSubmit()
  }
}
